import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect, useCallback } from "react";
import { getCart, removeCartItem } from "../../actions/cartAction";

import BreadcrumbCom from "../BreadcrumbCom";
import EmptyCardError from "../EmptyCardError";
import PageTitle from "../Helpers/PageTitle";
import Layout from "../Partials/Layout";
import ProductsTable from "./ProductsTable";
import ProductsTable_InProgress from "./ProductsTable_InProgress";

import "../SubAccount/subAccount.css";

export default function CartPage({ cart = true }) {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const userId = searchParams.get("userId");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  //validate user
  const { search } = useLocation(); //search is gonna be "/Home"
  const redirectInUrl = new URLSearchParams(search).get("redirect");
  const redirect = redirectInUrl ? redirectInUrl : "/Login"; // check if redirect url exist

  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo, userLoading, userError } = userSignin;

  //permissions
  const placeOrderPermission = userInfo?.result?.user?.permissions?.PlaceOrder;

  //get cart
  const cartItems = useSelector((state) => state.getCart);
  const { loading, error, cartItems: items } = cartItems;
  const [localItems, setLocalItems] = useState([]);

  /* logic
   Update quantity of items
   1) When cart page is rendered, cartItems is retreve from the API 
      and is transffered to items
   2) whenever there is a change in items, localItems state is updated. 
   3) And transffer "updateLocalItems" which is the function storing localItems to child component as a prop
   4) In child component when the quantity of items adjust, the updated quantity of item is stored to DB via updateCart API
      and right after that, Get updatedCartItems by calling getCart. 
      Call the callback function "updateLocalItems" from parent component with the response from getCart API.
  */

  const updateLocalItems = (updatedItems) => {
    if (Array.isArray(updatedItems)) {
      setLocalItems(updatedItems);
    } else {
      // ignore null/undefined to avoid clearing the table
      console.log("updateLocalItems ignored non-array:", updatedItems);
    }
    // console.log("updatedItems: ", updatedItems);
    // console.log("localItems: ", localItems);
  };

  useEffect(() => {
    const next = items?.data?.result;
    if (Array.isArray(next)) {
      setLocalItems(next);
    }
    // else: do nothing; keep showing the last good list while loading/errors
  }, [items]);

  /* Delete items logic
    1) declear local cartItems in parent component
    2) set local cartItems state whenever global cartItems is updated from API
    3) send updated local cartItems state and a handler for setting local cartItems stateto child component as a parameter
    4) Create onClick in button and a handler for that
    5) Insert a handler for setting local cartItems state which is coming from parent component as a component parameter 
  */
  const handleItemRemoved = (itemProductId) => {
    setLocalItems((prevState) =>
      prevState.filter((item) => item.pid !== itemProductId),
    );
  };

  useEffect(() => {
    if (!userInfo) {
      alert("Please sign in to access our website. ");

      // Remove IRG token
      localStorage.removeItem("IRGAccesstoken");
      localStorage.removeItem("IRGtokenExpiry");

      navigate(redirect);
    } else {
      console.log("You are already logined ");
    }
    dispatch(getCart(userId));
  }, [dispatch, navigate, redirect, userInfo]);

  return (
    <Layout childrenClasses={cart ? "pt-0 pb-0" : ""}>
      {cart === false ? (
        <div className="cart-page-wrapper w-full">
          <div className="container-x mx-auto">
            <BreadcrumbCom
              paths={[
                { name: "home", path: "/" },
                { name: "Cart", path: "/cart" },
              ]}
            />
            <EmptyCardError />
          </div>
        </div>
      ) : (
        <div className="cart-page-wrapper w-full bg-white pb-[60px]">
          <div className="w-full">
            <PageTitle
              title="Your Cart"
              breadcrumb={[
                { name: "home", path: "/" },
                { name: "cart", path: "/cart" },
              ]}
            />
          </div>

          <div className="w-full mt-[23px]">
            <div className="container-x mx-auto">
              <ProductsTable_InProgress
                className="mb-[30px]"
                //cartItems={items?.data.result}
                updateLocalItems={updateLocalItems}
                cartItems={localItems}
                onItemRemoved={handleItemRemoved}
                placeOrderPermission={placeOrderPermission}
              />
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
